import React, { useState, useEffect } from 'react'
import config from "config.json";
import useFetch from "hooks/useFetch";

interface HotelImage {
    hotel_code: string;
    photos: string[];
}

interface HotelImageDataResponse {
    default_image: string;
    hoteles: HotelImage[];
}

export default function SectionHotelData({hotelCode}: {hotelCode: string| null}) { 

    const [hotelImage, setHotelImage] = useState<string>("");
    const { data: hotelImagesData, error: hotelImagesError, fetchData: fetchHotelImages } = useFetch<HotelImageDataResponse>(
        "GET",
        `${config.backend_url}/setia/hoteles/ver_todas_fotos`,
        { "Content-Type": "application/json" }
    );

    useEffect(() => {
        fetchHotelImages()
        fetchData()
    }, [])

    useEffect(() => {
        if (hotelImagesData) {
            const hotelData = hotelImagesData.hoteles.find(
                (hotel) => hotel.hotel_code === hotelCode
            );

            if (hotelData) {
                setHotelImage(hotelData.photos[0]);
            } else {
                setHotelImage(hotelImagesData.default_image);
            }
        }
    }, [hotelImagesData]);

    const [hotel, setHotel] = useState<any>(null);
    const { data, isLoading, error, fetchData } = useFetch(
        "GET",
        `${config.backend_url}/setia/hotel/detalle?codigo=${hotelCode}`,
        { "Content-Type": "application/json" }
    );

    useEffect(() => {
        if (data) {
            setHotel(data);
        }
    }, [data]);

    return (
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="flex-shrink-0 w-full sm:w-40">
                <div className="aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
                    <img
                        alt=""
                        className="absolute inset-0 object-cover"
                        sizes="200px"
                        src={hotelImage}
                    />
                </div>
            </div>
            <div className="py-5 sm:px-5 space-y-3">
                <div>
                    <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
                        Tu reserva en:
                    </span>
                    <span className="text-base font-medium mt-1 block">
                        {hotel?.descripcion || "Nombre del Hotel"}
                    </span>
                </div>

                <div className="w-10 border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                    </svg>
                    <div className="flex flex-col">
                        <span className="">{hotel?.direccion}</span>
                        <p className="">{hotel?.ciudad}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
